module.exports = __webpack_public_path__ + "static/img/fast-seller-badge.591ce7cb.svg";